import axios from 'axios';
import { FETCH_ALL_TRAINERS } from '../constants/actionTypes';

export const fetchAllTrainers = history => async dispatch => {
  axios
    .get(`/api/fetch-trainers`)
    .then(res => {
      return dispatch({
        type: FETCH_ALL_TRAINERS,
        payload: res.data
      });
    })
    .catch(() => history.push('/404err'));
};
